const zh_CN = {
    info: {
        title: "余按钮",
        info: "信息",
        author: "按钮联合工作室 × 幽世鬼神的居酒屋 2024",
        null: "空",
        subscriber: "当前Youtube订阅数为：",
        audioStaff: "鸣谢名单以及网站相关",
        toGithub: "请在GitHub提出您的宝贵意见",
        notOfficial: "本站为爱好者作品，和hololive官方没有关联。上传的音频文件若有侵犯您的权益，请立即联系我们删除:support@vbup.org",
        overlapTips: "叠加播放无法暂停，同时会创建大量线程，建议偶尔刷新页面"
    },
    action: {
        toggleNavbar: "切换导航栏",
        random: "● 今日随机",
        share: "分享到Twitter查看",
        placeholder: "请输入昵称",
        live: "● 信息面板",
        vtbbtn: "VTuber按钮合集",
        close: "关闭",
        copy: "复制",
        stopvoice: "停止",
        randomplay: "随机选择",
        overlap: "重叠播放",
        autoplay: "自动播放",
        playing: "正在播放：",
        noplay: "",
        adtitle: "● 联动项目",
        weekly: "幽世鬼神的居酒屋周报",
        plan: "计划日期",
        ing: "正在直播"
    },
    lang: {
        'zh-CN': "简体中文",
        'ja-JP': "日本語",
        "en-US": "English"
    }
}
export default zh_CN;